import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import { useAuth } from '../context/AuthContext'

export default function SetPassword() {
  const navigate = useNavigate()
  const { passwordRecovery, clearPasswordRecovery } = useAuth()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }

    setLoading(true)
    const { error: updateError } = await supabase.auth.updateUser({ password })
    setLoading(false)

    if (updateError) {
      setError(updateError.message)
      return
    }

    clearPasswordRecovery()
    navigate('/')
  }

  return (
    <main className="min-h-screen bg-off-white flex items-center justify-center p-4">
      <div className="bg-navy rounded-2xl shadow-2xl overflow-hidden w-full max-w-md">
        <div className="h-1 bg-gradient-to-r from-gold via-[#D4A843] to-gold/10" />
        <div className="p-8 flex flex-col items-center">
          <img src="/4lc-logo.png" alt="4 Level Compass" className="w-48 mb-6" />
          <h1 className="font-oswald text-2xl text-white mb-1">
            {passwordRecovery ? 'Reset Your Password' : 'Create Your Password'}
          </h1>
          <p className="font-inter text-sm text-white/50 mb-6">
            {passwordRecovery ? 'Enter a new password for your account' : 'Set a password to access your client portal'}
          </p>

          <form onSubmit={handleSubmit} className="w-full space-y-4">
            <div>
              <label htmlFor="set-password" className="block font-inter text-sm text-white/70 mb-1">Password</label>
              <input
                id="set-password"
                type="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-white/20 bg-transparent rounded-lg px-4 py-2.5 font-inter text-sm text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-gold"
                placeholder="At least 8 characters"
                required
              />
            </div>

            <div>
              <label htmlFor="confirm-password" className="block font-inter text-sm text-white/70 mb-1">Confirm Password</label>
              <input
                id="confirm-password"
                type="password"
                name="confirm-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full border border-white/20 bg-transparent rounded-lg px-4 py-2.5 font-inter text-sm text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-gold"
                placeholder="Re-enter your password"
                required
              />
            </div>

            {error && (
              <p className="text-brand-red text-sm font-inter">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gold text-navy font-oswald text-lg py-2.5 rounded-lg hover:opacity-90 transition disabled:opacity-50 uppercase tracking-wider"
            >
              {loading ? 'Setting Password...' : 'Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </main>
  )
}
